import { defineMessages } from 'react-intl';

export default defineMessages({
  calendarTitleAriaLabel: {
    id: 'CustomDateRange.Calendar.title.ariaLabel',
    defaultMessage: 'Select your date',
  },
  calendarPreviousMonthButtonAriaLabel: {
    id: 'CustomDateRange.Calendar.previousMonthButton.ariaLabel',
    defaultMessage: 'Switch to the previous month',
  },
  calendarNextMonthButtonAriaLabel: {
    id: 'CustomDateRange.Calendar.nextMonthButton.ariaLabel',
    defaultMessage: 'Switch to the next month',
  },
  calendarInitialInstructionsAriaLabel: {
    id: 'CustomDateRange.Calendar.initialInstructions.ariaLabel',
    defaultMessage:
      'You can use the arrow keys, Home, End, PageUp and PageDown keys to navigate within the calendar grid.',
  },
  calendarDateButtonAriaLabel: {
    id: 'CustomDateRange.Calendar.DateButton.ariaLabel',
    defaultMessage: 'Choose {date}',
  },
  searchDate: {
    id: 'CustomDateRange.SearchDate',
    defaultMessage: 'Search Date',
  },
});
